import { FC } from 'react'
import dynamic from 'next/dynamic'
import { LayoutHeader } from '@/components/domains/layouts'

const NoSSRSearchBody = dynamic(() => import('@/components/domains/search/SearchBody'), {
  ssr: false,
})

const PageSearch: FC = () => {
  return (
    <>
      <LayoutHeader />
      <NoSSRSearchBody />
    </>
  )
}

export default PageSearch
